import { create } from "zustand";
import { nanoid } from "nanoid";

import { Gender } from "@shared/constants/gender";
import { DoctorRoles } from "@shared/constants/doctorRoles";
import { deepClone } from "@shared/utils/deepClone";

const initialState = {
  id: nanoid(21),
  loading: false,
  userType: "",
  firstName: "",
  lastName: "",
  email: "",
  phoneNumber: "",
  avatar: null,
  languages: ["fr"],
  birthDate: "",
  gender: Gender[0].value,
  address: {
    streetNumber: "",
    streetName: "",
    city: "",
    district: "",
    state: "",
    country: "",
    postalCode: "",
    coordinates: {
      latitude: 0,
      longitude: 0,
    },
  },
  nir: "",
  birthPlace: "",
  bloodGroup: "",
  medicalBackground: "",
  treatments: "",
  allergies: "",
  certificationNumber: "", // Text
  advancedCertificationNumber: "", // Text
  workZone: "", // Geocoordinates / city ?
  assistantDescription: "", //Text
  assistantProfile: "", //
  assistantAffiliation: "", // finess -> search in db -> if exists in db attach or create for future attach
  expertise: "", // Text ?
  rpps: "",
  communication: "",
  doctorDescription: "",
  doctorSpecialty: [DoctorRoles[0].value],
  qualifications: "",
  finess: "",
  isAlreadyRegistered: false,
  error: {},
}

export const useNewUserStore = create((set) => ({
  ...deepClone(initialState),
  reset: () => set(deepClone(initialState)),

  setLoading: (loading) => set({ loading }),  
  setUserType: (userType) => set({ userType }),

  // UserInfo
  setFirstName: (firstName) => set({ firstName }),
  setLastName: (lastName) => set({ lastName }),
  setEmail: (email) => set({ email }),
  setPhoneNumber: (phoneNumber) => set({ phoneNumber }),
  setAvatar: (avatar) => set({ avatar }),
  setLanguages: (languages) => set({ languages }),

  // All except organization
  setBirthDate: (birthDate) => set({ birthDate }),
  setGender: (gender) => set({ gender }),
  
  setAddress: (address) => set({ address }),

  // Patient
  setNIR: (nir) => set({ nir }),
  setBirthPlace: (birthPlace) => set({ birthPlace }),
  setBloodGroup: (bloodGroup) => set({ bloodGroup }),
  setMedicalBackground: (medicalBackground) => set({ medicalBackground }),
  setTreatments: (treatments) => set({ treatments }),
  setAllergies: (allergies) => set({ allergies }),

  // Assistant
  setCertificationNumber: (certificationNumber) => set({ certificationNumber }),
  setAdvancedCertificationNumber: (advancedCertificationNumber) =>
    set({ advancedCertificationNumber }),
  setWorkZone: (workZone) => set({ workZone }),
  setAssistantDescription: (assistantDescription) =>
    set({ assistantDescription }),
  setAssistantProfile: (assistantProfile) => set({ assistantProfile }),
  setAssistantAffiliation: (assistantAffiliation) =>
    set({ assistantAffiliation }),
  setExpertise: (expertise) => set({ expertise }),

  // Doctor
  setRpps: (rpps) => set({ rpps }),
  setCommunication: (communication) => set({ communication }),
  setDoctorDescription: (doctorDescription) => set({ doctorDescription }),
  setDoctorSpecialty: (doctorSpecialty) => set({ doctorSpecialty }),
  setQualifications: (qualifications) => set({ qualifications }),

  // Organization
  setFiness: (finess) => set({ finess }),

  setIsAlreadyRegistered: (isAlreadyRegistered) => set({ isAlreadyRegistered }),
  setError: (error) => set({ error }),
  set,
}));
